import { render, staticRenderFns } from "./spacesCommon.vue?vue&type=template&id=60f59e76&"
import script from "./spacesCommon.vue?vue&type=script&lang=js&"
export * from "./spacesCommon.vue?vue&type=script&lang=js&"
import style0 from "./spacesCommon.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports